webpackJsonp([86],{

/***/ "17Nb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3fD9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4G/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSimilarAds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPeopleAlsoViewedAds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sendGetContactReq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sendReq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pushVapDataToDataLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadQDFP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bigBrotherEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sendOtp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resendOtp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return verifyOtp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__("5aIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FetchHelper_js__ = __webpack_require__("kQy/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UtmHelper_js__ = __webpack_require__("BoEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__("aB7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommonHelper__ = __webpack_require__("6QU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommonHelper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CommonHelper__);







var apiHelper = new __WEBPACK_IMPORTED_MODULE_1__FetchHelper_js__["a" /* default */]();
var utmParams = new __WEBPACK_IMPORTED_MODULE_2__UtmHelper_js__["a" /* default */]();

var getSimilarAds = function getSimilarAds(adId) {
    return new Promise(function (resolve, reject) {
        var params = {
            url: __WEBPACK_IMPORTED_MODULE_3__config_js__["b" /* apiUrl */] + "/vap/get-relevant-ads/?aj=1&adId=" + adId
        };

        apiHelper.request('get', params).then(function (response) {
            resolve(response);
        });
    });
};

var getPeopleAlsoViewedAds = function getPeopleAlsoViewedAds(adId) {
    return new Promise(function (resolve, reject) {
        var params = {
            url: __WEBPACK_IMPORTED_MODULE_3__config_js__["b" /* apiUrl */] + "/vap/people-also-viewed-ads/?aj=1&adId=" + adId
        };

        apiHelper.request('get', params).then(function (response) {
            resolve(response);
        });
    });
};

var sendGetContactReq = function sendGetContactReq(name, email, mobile, csrf, adId) {
    return new Promise(function (resolve, reject) {
        var data = {
            adId: adId,
            mobile: mobile,
            emailId: email,
            name: name,
            leadType: "CALL",
            campaignName: "RESPONSE_CALL",
            campaignId: "RESPONSE_CALL",
            captureSource: "VAP",
            CSRFKey: csrf.key,
            CSRFValue: csrf.value
        };
        var params = {
            url: __WEBPACK_IMPORTED_MODULE_3__config_js__["b" /* apiUrl */] + "/ad-owner-contact-details/get-contact-details?isAjaxRequest=true&_t=" + csrf.ftoken,
            data: data,
            isJson: true
        };
        apiHelper.request('POST', params).then(function (response) {
            resolve(response);
        });
    });
};

var sendReq = function sendReq(name, email, mobile, csrf, adId) {
    return new Promise(function (resolve, reject) {
        var data = {
            adId: adId,
            mobile: mobile,
            emailId: email,
            name: name,
            leadType: "CALL",
            campaignName: "RESPONSE_CALL",
            campaignId: "RESPONSE_CALL",
            captureSource: "VAP"
        };
        var params = {
            url: __WEBPACK_IMPORTED_MODULE_3__config_js__["b" /* apiUrl */] + "/ad-owner-contact-details/get-ad-owner-contact-details?_t=" + csrf.ftoken,
            data: data,
            isJson: true
        };

        apiHelper.request('POST', params).then(function (response) {
            resolve(response);
        });
    });
};

var pushVapDataToDataLayer = function pushVapDataToDataLayer(data, user, deviceType) {
    var cookies = new __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default.a();
    var adData = data.adData,
        categoryGid = data.categoryGid,
        categoryPGid = data.categoryPGid,
        subCategoryName = data.subCategoryName;

    var isPremium = data.adStyle == "PREMIUM" ? true : false;
    var utmParameters = utmParams.getUtmParameters();
    var dataToPush = {
        "Ad_id": adData.adId,
        "lang": "English",
        "USER_CITY_NAME": adData.cityName,
        "Category_id": categoryPGid,
        "SubCategory_id": categoryGid,
        "SubCategory_Name": subCategoryName,
        "Category_Name": "Cars-Bikes",
        "USER_CITY_ID": adData.cityId,
        "referrer": document.referrer,
        "utmSource": utmParameters.utm_source,
        "utmMedium": utmParameters.utm_medium,
        "utmCampaign": utmParameters.utm_campaign,
        "deviceType": deviceType,
        "locality": adData.adLocality,
        "brand": adData.attributeData.Brand_name,
        "model": adData.attributeData.Model,
        "variant": adData.attributeData.Variant,
        "priceOfVehicle": adData.price,
        "kmsDriven": adData.attributeData.Kms_Driven,
        "yearOfRegn": adData.attributeData.Year,
        "isPremium": isPremium,
        "isAssured": adData.attributeData.adOfferingType === 'assured',
        "isPreferredSeller": adData.attributeData.adOfferingType === 'preferredSeller',
        "isInspected": adData.attributeData.adOfferingType === 'inspected',
        "emiTest": adData.emiEnabled,
        "PAGE_TYPE": "VAP"
    };

    if (adData.attributeData.Fuel_Type) {
        dataToPush.Fuel_Type = adData.attributeData.Fuel_Type;
    }

    if (categoryGid == 72) {
        dataToPush.Bike_Type = adData.attributeData.Bike_Type;
    }

    if (user.loggedIn) {
        var name = user.name,
            email = user.email,
            mobile = user.mobile;

        dataToPush.name = name;
        dataToPush.email = email;
        dataToPush.mobile = mobile;
        dataToPush.userId = cookies.get("__u");
        dataToPush.isLoggedIn = 1;
    } else {
        dataToPush.isLoggedIn = 0;
    }

    if (typeof dataLayer != "undefined" && dataLayer) {
        dataLayer.push(dataToPush);
    }
};

var loadQDFP = function loadQDFP(vapData, IsLoggedIn, channel) {
    var adData = vapData.adData,
        metaCategoryName = vapData.metaCategoryName,
        subCategoryName = vapData.subCategoryName;

    var script = document.createElement("script");
    script.innerHTML = "window.qdfp_vp={id: 'old_vap_page',ptargeting: [{key:'City',value: '" + adData.cityName + "'},{key: 'Category',value: '" + metaCategoryName + "'},{key: 'Subcategory',value:'" + subCategoryName + "'},{key: 'Brand_name',value:  '" + adData.attributeData.Brand_name + "'},{key: 'Model',value:'" + adData.attributeData.Model + "'},{key: 'Price',value:'" + adData.attributeData.Price + "'},{key: 'isLoggedIn',value:" + Number(IsLoggedIn) + " }]}";
    document.head.appendChild(script);

    var imported = document.createElement('script');
    imported.src = "https://teja9.kuikr.com/public/mon/qapqdfp/cars_4.0.0/cnb/" + (channel == 'desktop' ? 'index.js' : 'index-msite.js');
    document.body.appendChild(imported);
};

var bigBrotherEvents = function bigBrotherEvents(vapData, event, channel) {
    var cookies = new __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default.a();
    var adData = vapData.adData,
        categoryGid = vapData.categoryGid,
        subCategoryName = vapData.subCategoryName;

    var postData = {
        "user_db_id": cookies.get("__u"),
        "ad_id": adData.adId,
        "cat_id": 60,
        "cat_name": "Cars-Bikes",
        "subcat_id": categoryGid,
        "subcat_name": subCategoryName,
        "city_id": adData.cityId,
        "city_name": adData.cityName
    };
    Object(__WEBPACK_IMPORTED_MODULE_4__CommonHelper__["bigBrotherEvents"])(postData, event, channel);
};

var sendOtp = function sendOtp(mobile, csrf) {
    return new Promise(function (resolve, reject) {
        var apiUrl = 'https://www.quikr.com/core/quikrcom/ad-owner-contact-details/send-otp?isAjaxRequest=true&_t=' + csrf.ftoken;
        var data = new URLSearchParams();
        data.append('user', mobile);
        data.append('CSRFKey', csrf.key);
        data.append('CSRFValue', csrf.value);

        var params = {
            url: apiUrl,
            data: data
        };

        apiHelper.request('POST', params).then(function (response) {
            resolve(response);
        });
    });
};

var resendOtp = function resendOtp(csrf) {
    return new Promise(function (resolve, reject) {
        var apiUrl = 'https://www.quikr.com/core/quikrcom/ad-owner-contact-details/resend-otp?isAjaxRequest=true&_t=' + csrf.ftoken;
        var data = new URLSearchParams();
        data.append('CSRFKey', csrf.key);
        data.append('CSRFValue', csrf.value);

        var params = {
            url: apiUrl,
            data: data
        };

        apiHelper.request('POST', params).then(function (response) {
            resolve(response);
        });
    });
};

var verifyOtp = function verifyOtp(otp, mobile, csrf) {
    return new Promise(function (resolve, reject) {
        var apiUrl = 'https://www.quikr.com/core/quikrcom/ad-owner-contact-details/verify-otp?isAjaxRequest=true&_t=' + csrf.ftoken;

        var data = new URLSearchParams();
        data.append('otp', otp);
        data.append('GreetingName', mobile);
        data.append('CSRFKey', csrf.key);
        data.append('CSRFValue', csrf.value);

        var params = {
            url: apiUrl,
            data: data
        };

        apiHelper.request('POST', params).then(function (response) {
            resolve(response);
        });
    });
};

/***/ }),

/***/ "4WcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", { points: "15,62 41,36 15,10 23,2 57,36 23,70" });

var RightArrow = function RightArrow(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "svg",
    { viewBox: "0 0 72 72", "class": props.class },
    _ref
  );
};
/* harmony default export */ __webpack_exports__["a"] = (RightArrow);

/***/ }),

/***/ "8adH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8wcj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9FV6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GoDe":
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__("CK2z");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PlainComponent = function (_React$Component) {
    _inherits(PlainComponent, _React$Component);

    function PlainComponent() {
        _classCallCheck(this, PlainComponent);

        return _possibleConstructorReturn(this, (PlainComponent.__proto__ || Object.getPrototypeOf(PlainComponent)).apply(this, arguments));
    }

    _createClass(PlainComponent, [{
        key: "render",
        value: function render() {
            return null;
        }
    }]);

    return PlainComponent;
}(_react2.default.Component);

exports.default = PlainComponent;
module.exports = exports["default"];

/***/ }),

/***/ "HipT":
/***/ (function(module, exports) {

exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText",
    ITEM_PROP: "itemprop"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "class": "className"
};

/***/ }),

/***/ "IZFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polygon", { points: "57,62 31,36 57,10 49,2 15,36 49,70" });

var LeftArrow = function LeftArrow(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "svg",
    { viewBox: "0 0 72 72", "class": props.class },
    _ref
  );
};
/* harmony default export */ __webpack_exports__["a"] = (LeftArrow);

/***/ }),

/***/ "PTRK":
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__("vfkZ");
var isArguments = __webpack_require__("zSvO");

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

    // 7.3. Other pairs that do not both pass typeof value == 'object',
    // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

    // 7.4. For all other Object pairs, including Array objects, equivalence is
    // determined by having the same number of owned properties (as verified
    // with Object.prototype.hasOwnProperty.call), the same set of keys
    // (although not necessarily the same order), equivalent values for every
    // corresponding key, and an identical 'prototype' property. Note: this
    // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
};

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {
    //happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length) return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}

/***/ }),

/***/ "S/Km":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss__ = __webpack_require__("XKSl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_scss__);




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	{ 'class': 'qc-loader-spinner' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': 'qc-loader-spinner__img' })
);

var LoaderSpinner = function LoaderSpinner(props) {
	return _ref;
};
/* harmony default export */ __webpack_exports__["a"] = (LoaderSpinner);

/***/ }),

/***/ "SiSP":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
};

/***/ }),

/***/ "XKSl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lG4b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = __webpack_require__("CK2z");
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__("SiSP"));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;

/***/ }),

/***/ "pzlJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_textfield_mdc_textfield_scss__ = __webpack_require__("8wcj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_textfield_mdc_textfield_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_textfield_mdc_textfield_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss__ = __webpack_require__("17Nb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Import dependencies.
 */



/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */



/**
 * Create the component.
 */

var Checkbox = function (_Component) {
	_inherits(Checkbox, _Component);

	function Checkbox(props) {
		_classCallCheck(this, Checkbox);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.handleFocus = function (e) {
			_this.setState({ focused: true });
			_this.props.onFocus && _this.props.onFocus(e);
		};

		_this.handleBlur = function (e) {
			// TODO: find a way to match validity with custom provided helptext.
			_this.setState({ focused: false });
			_this.props.onBlur && _this.props.onBlur(e);
		};

		_this.handleChange = function (e) {
			_this.props.onChange && _this.props.onChange(e);
		};

		_this.state = {
			focused: false
		};
		return _this;
	}

	Checkbox.prototype.render = function render(_ref, _ref2, context) {
		var focused = _ref2.focused;

		var id = _ref.id,
		    type = _ref.type,
		    value = _ref.value,
		    label = _ref.label,
		    placeholder = _ref.placeholder,
		    disabled = _ref.disabled,
		    dense = _ref.dense,
		    fullWidth = _ref.fullWidth,
		    _ref$inputIcon = _ref.inputIcon,
		    inputIcon = _ref$inputIcon === undefined ? false : _ref$inputIcon,
		    hasInputIcon = _ref.hasInputIcon,
		    required = _ref.required,
		    error = _ref.error,
		    onFocus = _ref.onFocus,
		    onBlur = _ref.onBlur,
		    onChange = _ref.onChange,
		    inputClassName = _ref.inputClassName,
		    helpTextPersistent = _ref.helpTextPersistent,
		    props = _objectWithoutProperties(_ref, ['id', 'type', 'value', 'label', 'placeholder', 'disabled', 'dense', 'fullWidth', 'inputIcon', 'hasInputIcon', 'required', 'error', 'onFocus', 'onBlur', 'onChange', 'inputClassName', 'helpTextPersistent']);

		var classes = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-textfield mdc-textfield--upgraded', {
			'mdc-textfield--dense': dense,
			'mdc-textfield--disabled': disabled,
			'mdc-textfield--focused': focused,
			'mdc-textfield--icon': inputIcon,
			'mdc-textfield--invalid': error
		}, { 'mdc-textfield--full': fullWidth });
		var wrapperClass = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('', { 'mdc-textfield--full': fullWidth });

		var classesLabel = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-textfield__label', {
			'mdc-textfield__label--float-above': focused || value && value.length
		});

		var classesHelptext = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('mdc-textfield-helptext', {
			'mdc-textfield-helptext--persistent': helpTextPersistent,
			'mdc-textfield-helptext--validation-msg': error
		});
		var idInternal = id ? id : new Date().getTime() + '.' + Math.floor(Math.random() * 100);
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': wrapperClass },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'label',
				{ 'class': classes },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', _extends({
					'class': 'mdc-textfield__input ' + (inputClassName || ''),
					id: idInternal,
					type: type,
					value: value,
					placeholder: focused ? placeholder : false,
					disabled: disabled,
					required: required,
					'aria-controls': idInternal + '-validation-msg',
					onFocus: this.handleFocus,
					onBlur: this.handleBlur,
					onChange: this.handleChange
				}, props)),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': classesLabel },
					label
				),
				inputIcon
			),
			!focused && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				{ id: idInternal + '-validation-msg', 'class': classesHelptext },
				error
			)
		);
	};

	return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "schv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q_mdc_elements_material_button__ = __webpack_require__("vkp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_q_mdc_quikr_core_text_field__ = __webpack_require__("pzlJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_q_mdc_elements_material_list__ = __webpack_require__("sRYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q_mdc_elements_material_list_item__ = __webpack_require__("ir2Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vap_components_loader__ = __webpack_require__("S/Km");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_VapHelper__ = __webpack_require__("4G/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_CommonHelper__ = __webpack_require__("6QU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_CommonHelper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__utils_CommonHelper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_scss__ = __webpack_require__("8adH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_scss__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_4_q_mdc_elements_material_list_item__["a" /* default */],
    { 'class': 'otp-title' },
    'Enter OTP'
);

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__vap_components_loader__["a" /* default */], null);

var Otp = function (_Component) {
    _inherits(Otp, _Component);

    function Otp(props) {
        _classCallCheck(this, Otp);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.generateOtp = function () {
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_VapHelper__["g" /* sendOtp */])(_this.mobile, _this.props.csrf).then(function (response) {
                _this.props.sendOtpEvent && Object(__WEBPACK_IMPORTED_MODULE_7__utils_CommonHelper__["pushToDataLayer"])({ event: _this.props.sendOtpEvent });
                if (response.data.status === 200) {} else if (response.data.error && response.data.message) {
                    alert(response.data.message);
                } else {
                    alert('Something went wrong');
                }
            });
        };

        _this.verifyOtp = function (e) {
            e && e.preventDefault();
            if (!/[0-9]{4}/.test(_this.state.otp)) {
                _this.setState({
                    otpError: 'Enter valid OTP'
                });
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_VapHelper__["i" /* verifyOtp */])(_this.state.otp, _this.mobile, _this.props.csrf).then(function (response) {
                _this.props.verifyOtpEvent && Object(__WEBPACK_IMPORTED_MODULE_7__utils_CommonHelper__["pushToDataLayer"])({ event: _this.props.verifyOtpEvent });
                if (response.data.status == 'SUCCESS') {
                    _this.setState({
                        showLoader: true
                    }, function () {
                        _this.props.successCallBack();
                    });
                } else {
                    if (response.data.error == 'Please enter correct OTP') {
                        alert(response.data.error);
                    } else if (response.data.message) {
                        alert(response.data.message);
                    } else {
                        alert('Something went wrong at our end. Please try after sometime.');
                    }
                }
            });
        };

        _this.handleOtp = function (e) {
            if (/[0-9]{4}/.test(e.target.value)) {
                _this.setState({
                    otp: e.target.value
                }, function () {
                    _this.verifyOtp();
                });
            }
        };

        _this.handleOtpChange = function (e) {
            _this.setState({ otp: e.target.value });
        };

        _this.resendOtp = function (e) {
            e && e.preventDefault();
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_VapHelper__["e" /* resendOtp */])(_this.props.csrf).then(function (response) {
                _this.props.resendOtpEvent && Object(__WEBPACK_IMPORTED_MODULE_7__utils_CommonHelper__["pushToDataLayer"])({ event: _this.props.resendOtpEvent });
                if (response.data.status == 200) {
                    _this.setState({
                        otpResend: true,
                        otpText: "OTP has been resent to"
                    });
                } else if (response.data.error && response.data.message) {
                    alert(response.data.message);
                } else {
                    alert('Something went wrong');
                }
            });
        };

        _this.state = {
            showLoader: false,
            otpResend: false,
            otpText: "We have sent the OTP on"
        };
        _this.mobile = _this.props.mobile;
        return _this;
    }

    Otp.prototype.componentDidMount = function componentDidMount() {
        this.generateOtp();
    };

    Otp.prototype.render = function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': 'otp-cont' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': 'otp-header' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'label',
                    null,
                    this.state.otpText
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'p',
                    null,
                    this.mobile,
                    ' - ',
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'span',
                        { onClick: this.props.openInput },
                        'Change'
                    )
                )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                __WEBPACK_IMPORTED_MODULE_3_q_mdc_elements_material_list__["a" /* default */],
                null,
                _ref,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4_q_mdc_elements_material_list_item__["a" /* default */],
                    null,
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'div',
                        { 'class': 'qc__otp-verify' },
                        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                            'div',
                            { 'class': 'qc__otp-verify--input-wrap' },
                            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'div',
                                { 'class': 'input-wrap__border1' },
                                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                    'div',
                                    { 'class': 'input-wrap__border2' },
                                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_q_mdc_quikr_core_text_field__["a" /* default */], { fullWidth: true, id: 'qc__otp-verify--input', oninput: this.handleOtp, onChange: this.handleOtpChange, type: 'tel', error: this.state.otpError, value: this.state.otp, maxlength: '4', required: true })
                                )
                            )
                        )
                    )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4_q_mdc_elements_material_list_item__["a" /* default */],
                    null,
                    this.state.showLoader ? _ref2 : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        __WEBPACK_IMPORTED_MODULE_1_q_mdc_elements_material_button__["a" /* default */],
                        { primary: true, unelevated: true, ripple: true, onClick: this.verifyOtp },
                        'VERIFY OTP'
                    )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4_q_mdc_elements_material_list_item__["a" /* default */],
                    { 'class': 'resend-link' },
                    'Didn\'t get it? ',
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'strong',
                        { title: 'Resend OTP', onClick: this.resendOtp },
                        'Resend OTP'
                    )
                )
            )
        );
    };

    return Otp;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Otp);

/***/ }),

/***/ "tbzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Carousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("xIV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__("I0+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_material_button__ = __webpack_require__("vkp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_left_arrow__ = __webpack_require__("IZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_right_arrow__ = __webpack_require__("4WcI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_scss__ = __webpack_require__("9FV6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// TODO: refactoring code
// Add default props

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__icons_left_arrow__["a" /* default */], null);

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__icons_right_arrow__["a" /* default */], null);

var Carousel = function (_Component) {
	_inherits(Carousel, _Component);

	function Carousel(props) {
		_classCallCheck(this, Carousel);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.addClonedItems = function (array) {
			var newArray = array.map(function (v) {
				var isSliding = false;
				v.attributes.onMouseUp = function () {
					if (_this.inTransition) {
						isSliding = true;
					}
				};
				v.attributes.onClick = function (e) {
					if (isSliding) {
						e.preventDefault();
						e.stopPropagation();
						return false;
					}
				};
				return v;
			});
			newArray.unshift(array.slice(-1)[0]);
			newArray.push(array[0]);
			return newArray;
		};

		_this.handleSlide = function (e) {
			_this.touchEndX = e.pageX;
			_this.touchEndY = e.pageY;
			var diffX = Math.abs(_this.touchEndX) - Math.abs(_this.touchStartX);
			var slidePosition = _this.state.slidePosition || 0;
			_this.animateSlide(_this.scrollRef, '0s', { X: diffX + slidePosition });
		};

		_this.getSlidePosition = function (updatedSlide) {
			var _this$props = _this.props,
			    infiniteScrolling = _this$props.infiniteScrolling,
			    slidesToScroll = _this$props.slidesToScroll,
			    centerMode = _this$props.centerMode;

			var updatedSlideAccordingToProps = updatedSlide;
			if (infiniteScrolling) {
				updatedSlideAccordingToProps += 1;
			}
			var slidePosition = -_this.itemWidth * updatedSlideAccordingToProps;
			if (centerMode) {
				slidePosition += _this.edgeWidth;
			}
			return slidePosition;
		};

		_this.getUpdatedSlide = function (diffX, length) {
			var updatedSlide = void 0,
			    direction = 0;
			var _this$props2 = _this.props,
			    infiniteScrolling = _this$props2.infiniteScrolling,
			    items = _this$props2.items;

			if (diffX >= 50) {
				direction = -1;
			} else if (diffX <= -50) {
				direction = 1;
			}
			var currentSlide = _this.state.currentSlide;
			updatedSlide = currentSlide + direction;
			if (updatedSlide < 0) {
				updatedSlide = 0;
				if (infiniteScrolling) {
					updatedSlide = length - 1;
				}
			} else if (updatedSlide > length - 1) {
				updatedSlide = length - 1;
				if (infiniteScrolling) {
					updatedSlide = 0;
				}
			}
			return updatedSlide;
		};

		_this.scrollToUpdatedSlide = function (updatedSlide) {
			if (!_this.pause) {
				var _this$props3 = _this.props,
				    infiniteScrolling = _this$props3.infiniteScrolling,
				    items = _this$props3.items;

				var slidePosition = _this.getSlidePosition(updatedSlide);
				if (infiniteScrolling) {
					if (updatedSlide === 0 && _this.state.currentSlide === items.length - 1) {
						_this.animateSlide(_this.scrollRef, '500ms', { X: _this.state.slidePosition - _this.itemWidth });
						setTimeout(function () {
							_this.animateSlide(_this.scrollRef, '0s', { X: slidePosition });
						}, 500);
					} else if (updatedSlide === items.length - 1 && _this.state.currentSlide === 0) {
						_this.animateSlide(_this.scrollRef, '500ms', { X: _this.state.slidePosition + _this.itemWidth });
						setTimeout(function () {
							_this.animateSlide(_this.scrollRef, '0s', { X: slidePosition });
						}, 500);
					} else {
						_this.animateSlide(_this.scrollRef, '500ms', { X: slidePosition });
					}
				} else {
					_this.animateSlide(_this.scrollRef, '500ms', { X: slidePosition });
				}
				_this.setState(function (prevState) {
					var _extends2;

					return {
						currentSlide: updatedSlide,
						slidePosition: slidePosition,
						loaded: _extends(prevState.loaded, (_extends2 = {}, _extends2[updatedSlide] = true, _extends2[updatedSlide + 1] = true, _extends2))
					};
				});
			}
		};

		_this.animateSlide = function () {
			var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.scrollRef;
			var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1s';
			var position = arguments[2];
			var _position$X = position.X,
			    X = _position$X === undefined ? 0 : _position$X,
			    _position$Y = position.Y,
			    Y = _position$Y === undefined ? 0 : _position$Y;

			ref.style['transition-duration'] = duration;
			ref.style.transform = 'translate(' + X + 'px, ' + Y + 'px)';
		};

		_this.handleSlideStart = function (e) {
			_this.touchStarted = true;
			_this.pause = true;
			_this.touchStartX = e.pageX;
			_this.touchStartY = e.pageY;
		};

		_this.handleSlideEnd = function (e) {
			_this.touchStarted = false;
			if (!_this.touchEndX) {
				return;
			}
			var diffX = Math.abs(_this.touchEndX) - Math.abs(_this.touchStartX);
			var items = _this.props.items;

			var updatedSlide = _this.getUpdatedSlide(diffX, items.length);
			_this.resetAutoPlay();
			_this.pause = false;
			_this.scrollToUpdatedSlide(updatedSlide);
			_this.touchEndX = null;
			_this.touchEndY = null;
			_this.touchStartX = null;
			_this.touchStartY = null;
		};

		_this.handleTouchMove = function (e) {
			if (_this.touchStarted) {
				_this.handleSlide(e.touches[0]);
			}
		};

		_this.handleTouchStart = function (e) {
			_this.handleSlideStart(e.touches[0]);
		};

		_this.handleTouchEnd = function (e) {
			if (_this.touchStarted) {
				_this.handleSlideEnd(e.touches[0]);
			}
		};

		_this.handleTouchLeave = function (e) {
			if (_this.touchStarted) {
				_this.handleSlideEnd(e.touches[0]);
			}
		};

		_this.handleMouseDown = function (e) {
			_this.handleSlideStart(e);
		};

		_this.handleMouseMove = function (e) {
			if (_this.touchStarted) {
				_this.inTransition = true;
				_this.handleSlide(e);
			}
		};

		_this.handleMouseUp = function (e) {
			if (_this.touchStarted) {
				_this.handleSlideEnd(e);
				_this.inTransition = false;
			}
		};

		_this.handleMouseOut = function (e) {
			if (_this.touchStarted) {
				_this.handleSlideEnd(e);
			}
		};

		_this.gotoSlide = function (slidePosition) {
			var _this$props4 = _this.props,
			    infiniteScrolling = _this$props4.infiniteScrolling,
			    items = _this$props4.items;
			var updatedSlide = _this.state.updatedSlide;

			if (infiniteScrolling) {
				if (updatedSlide === 0 && _this.state.currentSlide === items.length - 1) {
					_this.animateSlide(_this.scrollRef, '500ms', { X: _this.state.slidePosition - _this.itemWidth });
					setTimeout(function () {
						_this.animateSlide(_this.scrollRef, '0s', { X: slidePosition });
					}, 500);
				} else if (updatedSlide === items.length - 1 && _this.state.currentSlide === 0) {
					_this.animateSlide(_this.scrollRef, '500ms', { X: _this.state.slidePosition + _this.itemWidth });
					setTimeout(function () {
						_this.animateSlide(_this.scrollRef, '0s', { X: slidePosition });
					}, 500);
				} else {
					_this.animateSlide(_this.scrollRef, '500ms', { X: slidePosition });
				}
			} else {
				_this.animateSlide(_this.scrollRef, '500ms', { X: slidePosition });
			}
			_this.setState(function (prevState) {
				var _extends3;

				return {
					currentSlide: updatedSlide,
					slidePosition: slidePosition,
					loaded: _extends(prevState.loaded, (_extends3 = {}, _extends3[updatedSlide] = true, _extends3[updatedSlide + 1] = true, _extends3))
				};
			});
		};

		_this.nextSlide = function (e) {
			var currentSlide = _this.state.currentSlide;
			var _this$props5 = _this.props,
			    items = _this$props5.items,
			    slidesToShow = _this$props5.slidesToShow,
			    _this$props5$slidesTo = _this$props5.slidesToScroll,
			    slidesToScroll = _this$props5$slidesTo === undefined ? 1 : _this$props5$slidesTo;

			if (currentSlide + 1 <= items.length - slidesToShow) {
				// let slidePosition = this.getSlidePosition(currentSlide+1);
				_this.scrollToUpdatedSlide(currentSlide + slidesToScroll);
				_this.touchEndX = null;
				_this.touchEndY = null;
				_this.touchStartX = null;
				_this.touchStartY = null;
			}
			_this.props.nextSlide && _this.props.nextSlide(e, currentSlide + 1);
		};

		_this.prevSlide = function (e) {
			var currentSlide = _this.state.currentSlide;
			var _this$props$slidesToS = _this.props.slidesToScroll,
			    slidesToScroll = _this$props$slidesToS === undefined ? 1 : _this$props$slidesToS;

			if (currentSlide - 1 >= 0) {
				// let slidePosition = this.getSlidePosition(currentSlide-1);
				_this.scrollToUpdatedSlide(currentSlide - slidesToScroll);
				_this.touchEndX = null;
				_this.touchEndY = null;
				_this.touchStartX = null;
				_this.touchStartY = null;
			}
			_this.props.prevSlide && _this.props.prevSlide(e, currentSlide - 1);
		};

		_this.resetAutoPlay = function () {
			clearInterval(_this.autoPlay);
			if (_this.props.autoPlay) {
				_this.autoPlay = setInterval(function () {
					return _this.scrollToUpdatedSlide((_this.state.currentSlide + 1) % (_this.renderItems.length - 2));
				}, _this.props.autoPlayTimeout);
			}
		};

		_this.renderItems = props.items;
		_this.state = {
			currentSlide: _this.props.currentSlide ? _this.props.currentSlide : 0,
			loaded: {
				0: true,
				1: props.items.length >= 2 ? true : undefined
			}
		};

		if (props.infiniteScrolling) {
			_this.renderItems = _this.addClonedItems(props.items);
		}

		_this.itemWidth = null;
		_this.itemRef = null;
		_this.scrollRef = null;
		_this.noOfItems = null;
		_this.widthArray = [];
		_this.touchStarted = false;
		_this.touchStartX = null;
		_this.touchStartY = null;
		_this.touchEndX = null;
		_this.touchEndY = null;
		return _this;
	}

	Carousel.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		if (this.props.getControls) {
			this.props.getControls({
				getCurrentSlide: function getCurrentSlide() {
					return _this2.state.currentSlide;
				},
				goToSlide: this.scrollToUpdatedSlide
			});
		}
	};

	Carousel.prototype.componentDidMount = function componentDidMount() {
		var _this3 = this;

		if (this.itemRef) {
			if (this.props.autoPlay) {
				this.onBlur = function () {
					_this3.pause = true;
				};
				this.onFocus = function () {
					_this3.resetAutoPlay();
					_this3.pause = false;
				};
				window.addEventListener('blur', this.onBlur, { passive: true });
				window.addEventListener('focus', this.onFocus, { passive: true });
			}
			var scrollWidth = window.innerWidth;
			if (this.itemRef.parentElement) {
				scrollWidth = this.itemRef.parentElement.offsetWidth;
			}
			var _props = this.props,
			    _props$slidesToShow = _props.slidesToShow,
			    slidesToShow = _props$slidesToShow === undefined ? 1 : _props$slidesToShow,
			    _props$centerMode = _props.centerMode,
			    centerMode = _props$centerMode === undefined ? false : _props$centerMode,
			    _props$edgeWidth = _props.edgeWidth,
			    edgeWidth = _props$edgeWidth === undefined ? 15 : _props$edgeWidth,
			    _props$infiniteScroll = _props.infiniteScrolling,
			    infiniteScrolling = _props$infiniteScroll === undefined ? false : _props$infiniteScroll,
			    fixedWidth = _props.fixedWidth;


			this.edgeWidth = edgeWidth;

			this.itemWidth = scrollWidth / slidesToShow;
			if (centerMode) {
				this.itemWidth = (scrollWidth - 2 * this.edgeWidth) / slidesToShow;
			}
			if (fixedWidth) {
				this.itemWidth = fixedWidth < window.innerWidth - edgeWidth * 2 ? fixedWidth : window.innerWidth - edgeWidth * 2;
				this.edgeWidth = (scrollWidth - this.itemWidth) / 2;
				this.scrollToUpdatedSlide(0);
			}
			if (infiniteScrolling) {
				var updatedSlide = this.state.currentSlide;
				var slidePosition = this.getSlidePosition(updatedSlide);
				this.scrollRef.style.transform = 'translate(' + slidePosition + 'px, ' + 0 + 'px)';
				this.setState({
					slidePosition: slidePosition
				});
			}
			this.resetAutoPlay();
		}
	};

	Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (this.props.items != nextProps.items) {
			this.renderItems = nextProps.items;
			if (nextProps.infiniteScrolling) {
				this.renderItems = this.addClonedItems(nextProps.items);
			}
		}
		if (nextProps.currentSlide && this.state.currentSlide != nextProps.currentSlide) {
			this.scrollToUpdatedSlide(nextProps.currentSlide);
		}
	};

	Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
		clearInterval(this.autoPlay);
		window.removeEventListener('blur', this.onBlur);
		window.removeEventListener('focus', this.onFocus);
	};

	Carousel.prototype.render = function render() {
		var _this4 = this;

		// TODO: Handle infinite scrolling
		// TODO: Draggable false on images
		// GOOD TO HAVE: Lazy loading images, or lazy rendering
		var _props2 = this.props,
		    items = _props2.items,
		    _props2$dots = _props2.dots,
		    dots = _props2$dots === undefined ? false : _props2$dots,
		    _props2$buttons = _props2.buttons,
		    buttons = _props2$buttons === undefined ? false : _props2$buttons,
		    _props2$buttonsPositi = _props2.buttonsPosition,
		    buttonsPosition = _props2$buttonsPositi === undefined ? 'top' : _props2$buttonsPositi,
		    _props2$buttonsSize = _props2.buttonsSize,
		    buttonsSize = _props2$buttonsSize === undefined ? 'big' : _props2$buttonsSize,
		    slidesToShow = _props2.slidesToShow,
		    _props2$pagination = _props2.pagination,
		    pagination = _props2$pagination === undefined ? true : _props2$pagination,
		    _props2$slidesToScrol = _props2.slidesToScroll,
		    slidesToScroll = _props2$slidesToScrol === undefined ? 1 : _props2$slidesToScrol,
		    _props2$focusActive = _props2.focusActive,
		    focusActive = _props2$focusActive === undefined ? false : _props2$focusActive;
		var _state = this.state,
		    loaded = _state.loaded,
		    currentSlide = _state.currentSlide;


		var buttonsDivClass = '';
		if (buttons) {
			buttonsDivClass = __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('qc-carousel__buttons', buttonsPosition, buttonsSize);
		}
		var width = 0;
		if (!items) {
			return null;
		}
		if (!this.noOfItems) {
			this.noOfItems = items.length;
		}
		if (this.itemWidth) {
			width = this.itemWidth * (this.renderItems.length + 1);
		}
		var page = 1 + Number((currentSlide / slidesToShow).toFixed());

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': 'qc-carousel' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ ref: function ref(_ref4) {
						_this4.itemRef = _ref4;
					}, 'class': 'qc-carousel__track' },
				buttons && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': buttonsDivClass },
					pagination && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'p',
						null,
						page + ' of ' + (items.length / slidesToShow).toFixed()
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_2__elements_material_button__["a" /* default */],
						{ onClick: this.prevSlide, disabled: !(currentSlide - 1 >= 0) },
						_ref
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_2__elements_material_button__["a" /* default */],
						{ onClick: this.nextSlide, disabled: !(currentSlide + 1 <= items.length - slidesToShow) },
						_ref2
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{
						'class': 'qc-carousel__list',
						ref: function ref(_ref3) {
							_this4.scrollRef = _ref3;
						},
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						onTouchEnd: this.handleTouchEnd,
						onTouchLeave: this.handleTouchLeave,
						style: { width: width },
						onMouseDown: this.handleMouseDown,
						onMouseMove: this.handleMouseMove,
						onMouseUp: this.handleMouseUp,
						onMouseOut: this.handleMouseOut
					},
					this.renderItems.map(function (v, index) {
						return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ key: index, 'class': 'qc-carousel__item', style: { width: _this4.itemWidth, opacity: focusActive ? _this4.state.currentSlide == index ? 1 : 0.2 : 1 } },
							v
						);
					})
				)
			),
			dots && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'qc-carousel__dots' },
				this.props.items.map(function (v, index) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ 'class': index === _this4.state.currentSlide ? 'active' : '', onClick: function onClick() {
								return _this4.scrollToUpdatedSlide(index);
							} },
						index
					);
				})
			)
		);
	};

	return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);




Carousel.defaultProps = {
	autoPlay: false,
	autoPlayTimeout: 5000
};

/***/ }),

/***/ "vfkZ":
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;

exports.shim = shim;
function shim(obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
}

/***/ }),

/***/ "vm8l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wliT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../preact/dist/preact.js
var preact = __webpack_require__("xIV9");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: ../react-helmet/lib/Helmet.js
var Helmet = __webpack_require__("yJsN");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ../q-mdc/quikr/core/quikrCarousel/index.js
var quikrCarousel = __webpack_require__("tbzV");

// EXTERNAL MODULE: ../q-mdc/quikr/core/text-field/index.js
var text_field = __webpack_require__("pzlJ");

// EXTERNAL MODULE: ../q-mdc/elements/material-list-item/index.js
var material_list_item = __webpack_require__("ir2Q");

// EXTERNAL MODULE: ../q-mdc/elements/material-list/index.js
var material_list = __webpack_require__("sRYg");

// EXTERNAL MODULE: ../q-mdc/elements/material-button/index.js
var material_button = __webpack_require__("vkp0");

// EXTERNAL MODULE: ../q-cars/src/components/common/otp/index.js
var otp = __webpack_require__("schv");

// EXTERNAL MODULE: ../q-cars/src/utils/GTMHelper.js
var GTMHelper = __webpack_require__("XYp7");

// EXTERNAL MODULE: ../q-cars/src/utils/CommonHelper.js
var CommonHelper = __webpack_require__("6QU2");
var CommonHelper_default = /*#__PURE__*/__webpack_require__.n(CommonHelper);

// EXTERNAL MODULE: ../q-cars/src/utils/FetchHelper.js
var FetchHelper = __webpack_require__("kQy/");

// EXTERNAL MODULE: ../q-cars/src/config.js
var config = __webpack_require__("aB7+");

// EXTERNAL MODULE: ../q-cars/src/components/common/Partnerships/form/index.scss
var Partnerships_form = __webpack_require__("vm8l");
var form_default = /*#__PURE__*/__webpack_require__.n(Partnerships_form);

// CONCATENATED MODULE: ../q-cars/src/components/common/Partnerships/form/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var _ref = Object(preact["h"])(
    material_list_item["a" /* default */],
    { 'class': 'qc__termstext' },
    'By proceeding, you agree to our ',
    Object(preact["h"])(
        'a',
        { href: '/html/termsandconditions.php', target: '_blank' },
        'Terms of Use'
    ),
    ' and ',
    Object(preact["h"])(
        'a',
        { href: '/html/policies.php#privacy-policy', target: '_blank' },
        'Privacy Policy'
    )
);

var _ref2 = Object(preact["h"])(
    'div',
    { 'class': 'successMessage' },
    Object(preact["h"])('img', { src: 'https://teja10.kuikr.com/QuikrCars/Cars/assets/bikePoint.png', alt: 'success' }),
    Object(preact["h"])(
        'h1',
        null,
        'Thank you for your interest. We will connect with you soon.'
    )
);

var form_PartnershipForm = function (_Component) {
    _inherits(PartnershipForm, _Component);

    function PartnershipForm(props) {
        _classCallCheck(this, PartnershipForm);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.onInput = function (field) {
            return function (event) {
                var _extends2, _extends3;

                var hasError = Boolean(_this.validators[field] && _this.validators[field].every(function (validator) {
                    return validator(event.target.value);
                }));
                _this.setState({
                    errors: _extends({}, _this.state.errors, (_extends2 = {}, _extends2[field] = hasError, _extends2)),
                    values: _extends({}, _this.state.values, (_extends3 = {}, _extends3[field] = event.target.value, _extends3))
                });
            };
        };

        _this.backBtn = function () {
            _this.setState({
                showOtpForm: false,
                success: false
            });
        };

        _this.submitForm = function (event) {
            event.preventDefault();
            var _this$state = _this.state,
                values = _this$state.values,
                errors = _this$state.errors;

            var errorCheck = false;
            Object.keys(errors).map(function (keys) {
                if (!values[keys] || values[keys] === '' || errors[keys]) {
                    _this.setState(function (prevState) {
                        var _extends4;

                        return {
                            errors: _extends({}, prevState.errors, (_extends4 = {}, _extends4[keys] = true, _extends4))
                        };
                    });

                    errorCheck = true;
                }
            });
            if (!errorCheck) {
                var res = _this.state.values.name.split(" ");;
                var firstNamee = res.splice(0, 1).toString();
                var lastName = res.join();
                var CityData = _this.state.values.cityId.split(" ");
                _this.data = new URLSearchParams();
                var extras = _this.state.values;
                extras.fullName = _this.state.values.name;
                extras.firstName = firstNamee;
                extras.lastName = lastName || ' ';
                extras.cityName = CityData[1];
                _this.data.append('extras', JSON.stringify(extras));
                _this.data.append('campaignName', _this.props.formData.campaignName);
                _this.data.append('campaignId', _this.props.formData.campaignId);
                _this.data.append('cityId', CityData[0]);
                _this.data.append('name', _this.state.values.name);
                _this.data.append('mobile', _this.state.values.mobile);
                _this.data.append('email', _this.state.values.email);
                if ((_this.props.formData || {}).OTPCheck) {
                    _this.setState({
                        showOtpForm: true
                    });
                } else {
                    _this.apiCall(_this.data);
                }
            }
            //event.preventDefault();
        };

        _this.leadSubmit = function () {
            _this.apiCall(_this.data);
        };

        _this.apiCall = function (data) {
            var params = {
                url: config["b" /* apiUrl */] + '/lead-generation/rawlead?aj=1',
                data: data
            };
            _this.apiHelper.request('post', params).then(function (response) {
                _this.setState({ success: true, showOtpForm: false });
            });
        };

        _this.state = {
            values: {
                salutation: 'Mr.'
            },
            errors: {},
            success: false,
            showOtpForm: false
        };
        _this.validators = {};
        _this.apiHelper = new FetchHelper["a" /* default */]();
        return _this;
    }

    PartnershipForm.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var gtm = new GTMHelper["a" /* default */]();
        gtm.GTMCall();
        Object(CommonHelper["loadGA"])();
        Object(CommonHelper["pushToDataLayer"])({ event: this.props.formData.event });
        this.props.formData.textFields.map(function (data) {
            if (data.isRequired) {
                _this2.setState(function (prevState) {
                    var _extends5;

                    return {
                        errors: _extends({}, prevState.errors, (_extends5 = {}, _extends5[data.name] = null, _extends5))
                    };
                });
                if (data.name == 'mobile') {
                    _this2.validators[data.name] = [CommonHelper["isMobileValid"]];
                } else if (data.name == 'email') {
                    _this2.validators[data.name] = [CommonHelper["isEmailValid"]];
                } else if (data.name == 'pincode') {
                    _this2.validators[data.name] = [CommonHelper["isValidPincode"]];
                } else {
                    _this2.validators[data.name] = [CommonHelper["isRequired"]];
                }
            }
        });
    };

    PartnershipForm.prototype.render = function render(props) {
        var _this3 = this;

        if (props.formData) {
            var _state = this.state,
                success = _state.success,
                showOtpForm = _state.showOtpForm;

            return Object(preact["h"])(
                'div',
                { 'class': 'bmw-form' },
                !success && !showOtpForm && Object(preact["h"])(
                    'form',
                    null,
                    Object(preact["h"])(
                        'h5',
                        null,
                        props.formData.formTitle
                    ),
                    Object(preact["h"])(
                        material_list["a" /* default */],
                        null,
                        props.formData.textFields.map(function (data, index) {
                            {
                                return index == 0 || index == 1 ? Object(preact["h"])(
                                    material_list_item["a" /* default */],
                                    { 'class': index == 0 ? 'salutation' : '' },
                                    data.name == "salutation" ? Object(preact["h"])(
                                        'div',
                                        { 'class': 'qc__custom-select' },
                                        Object(preact["h"])(
                                            'div',
                                            null,
                                            Object(preact["h"])(
                                                'select',
                                                { hintText: data.name, name: data.name, onChange: _this3.onInput(data.name) },
                                                data.values.map(function (selectVal) {
                                                    return Object(preact["h"])(
                                                        'option',
                                                        { value: selectVal.id },
                                                        selectVal.value
                                                    );
                                                })
                                            )
                                        )
                                    ) : data.name == "name" && Object(preact["h"])(text_field["a" /* default */], { onChange: _this3.onInput(data.name), error: _this3.state.errors[data.name], name: data.name, value: _this3.state.values[data.name], fullWidth: true, type: data.type, label: data.labelName, required: true })
                                ) : data.type == "text" || data.type == "number" ? Object(preact["h"])(
                                    material_list_item["a" /* default */],
                                    null,
                                    Object(preact["h"])(text_field["a" /* default */], { onChange: _this3.onInput(data.name), maxLength: data.name == 'mobile' ? 10 : 40, error: _this3.state.errors[data.name], name: data.name, value: _this3.state.values[data.name], fullWidth: true, type: data.type, label: data.labelName, required: true })
                                ) : Object(preact["h"])(
                                    material_list_item["a" /* default */],
                                    null,
                                    Object(preact["h"])(
                                        'div',
                                        { 'class': _this3.state.errors[data.name] ? 'qc__custom-select error' : 'qc__custom-select' },
                                        Object(preact["h"])(
                                            'div',
                                            null,
                                            Object(preact["h"])(
                                                'select',
                                                { hintText: data.name, name: data.name, onChange: _this3.onInput(data.name) },
                                                data.values.map(function (selectData) {
                                                    return Object(preact["h"])(
                                                        'option',
                                                        { value: selectData.id },
                                                        selectData.value
                                                    );
                                                })
                                            )
                                        )
                                    )
                                );
                            }
                        }),
                        _ref,
                        Object(preact["h"])(
                            material_list_item["a" /* default */],
                            null,
                            Object(preact["h"])(
                                material_button["a" /* default */],
                                { primary: true, stroked: true, unelevated: true, full: true, onClick: this.submitForm, ripple: true },
                                props.formData.buttonName
                            )
                        )
                    )
                ),
                showOtpForm && Object(preact["h"])(
                    'div',
                    { 'class': 'otpForm' },
                    Object(preact["h"])(otp["a" /* default */], { openInput: this.backBtn, mobile: this.state.values.mobile, csrf: {
                            key: 'cars_test_drive',
                            ftoken: props.formData.fToken,
                            value: props.formData.csrf
                        }, successCallBack: this.leadSubmit })
                ),
                success && !showOtpForm && _ref2
            );
        }
    };

    return PartnershipForm;
}(preact["Component"]);

/* harmony default export */ var common_Partnerships_form = (form_PartnershipForm);
// CONCATENATED MODULE: ../q-cars/src/components/common/Partnerships/quikrLogo.js



var quikrLogo__ref = Object(preact["h"])(
	"svg",
	{ width: "100.8px", height: "60px", viewBox: "0 0 364.8 152", "enable-background": "new 0 0 364.8 152" },
	Object(preact["h"])("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", fill: "#32A349", d: "M108.75,45.48c1.4,15.98-4.92,42.58-16.83,54.12 c-2.69,2.6-5.72,4.74-8.97,6.47l-6.03-10.39c-2.36-4.02-4.7-6.53-7.1-8.09c3.88-2.43,6.54-5.97,8.66-10.91 c2.49-5.78,5.88-19.3,5.03-25.69c-0.93-7.03-5.68-12.66-16.73-13.33c-4.88-0.3-9.93,0.06-14.65,1.27 c-4.22,1.08-7.77,3.04-10.31,5.45c-6.01,5.66-9.86,19.85-10.36,27.98c-0.35,5.66,0.46,9.95,2.43,12.87 c3.56,5.3,9.25,5.83,14.89,5.74l4.28,0c6.8,0,12.5,0.73,18.33,10.65l7.43,12.81c4.16,6.8,4.88,8.82,15.04,8.87h22.84l-4.56,21.98 H86.39c-7.13,0-16.91-1.06-22.74-10.97l-8.71-15.01c-3.46-5.48-3.29-6.5-9.39-6.81c-6.83-0.35-14.34-1.21-18.58-2.84 C16.5,105.61,8.18,97.77,6.95,83.71c-0.31-3.52-0.23-7.29,0.22-11.29c0.51-4.48,1.63-9.9,2.71-14.29 c2.92-11.82,6.93-21.3,14.31-28.45c9.4-9.09,22.63-12.63,35.25-13.09c4.97-0.18,13.51,0.05,20.62,1.03 C95.65,19.75,107.29,28.79,108.75,45.48z"
	}),
	Object(preact["h"])("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", fill: "#1081C4", d: "M344.32,37.56c2.56,0,4.98,0.13,7.24,0.39 c1.28,0.14,2.51,0.33,3.68,0.56l-3.76,18.13c-7.34-2.25-19.27-1.2-22.05,7.77c-0.29,0.94-0.55,1.94-0.75,2.98l0,0.02l-8.3,39.81 l-0.31,1.51h-1.78H299.9h-2.68l0.47-2.29l9.15-44.25l0-0.01c0.34-1.55,0.79-3.1,1.36-4.65c0.54-1.49,1.19-2.96,1.94-4.39l0,0 c0.79-1.52,1.74-2.94,2.87-4.26c1.13-1.32,2.43-2.56,3.9-3.72l0.01-0.01c1.49-1.16,3.17-2.21,5.04-3.13 c1.86-0.92,3.9-1.72,6.11-2.4l0.02,0c2.23-0.67,4.72-1.18,7.46-1.52C338.26,37.73,341.18,37.56,344.32,37.56L344.32,37.56z M187.6,106.49l13.71-65.69l0.31-1.51h1.78h18.41h2.69l-0.48,2.29l-13.74,65.69l-0.3,1.44h-22.84L187.6,106.49L187.6,106.49z M211.67,6.94h16.09c2.12,0,3.49,1.73,3.06,3.85l-2.76,13.46c-0.43,2.12-2.52,3.84-4.63,3.84h-16.1c-2.12,0-3.49-1.73-3.06-3.84 l2.76-13.46C207.47,8.67,209.56,6.94,211.67,6.94L211.67,6.94z M143.51,110.45c3.14,0,6.06-0.17,8.76-0.5 c2.74-0.34,5.23-0.85,7.46-1.52l0.02,0c2.21-0.68,4.25-1.48,6.11-2.4c1.87-0.92,3.56-1.97,5.04-3.13l0.01,0 c1.47-1.16,2.77-2.4,3.9-3.72c1.12-1.32,2.08-2.74,2.87-4.26l0,0c0.75-1.43,1.4-2.9,1.94-4.39c0.56-1.55,1.01-3.1,1.36-4.65l0-0.01 l9.15-44.25l0.47-2.29h-2.68h-18.38h-1.78l-0.31,1.51l-8.3,39.81l0,0.02c-0.21,1.04-0.46,2.04-0.75,2.98 c-0.29,0.92-0.62,1.81-0.99,2.65l0,0c-0.37,0.8-0.79,1.53-1.25,2.2c-0.45,0.65-0.96,1.24-1.52,1.77c-0.55,0.51-1.16,0.96-1.84,1.36 c-0.7,0.41-1.44,0.75-2.24,1.03v0c-0.81,0.27-1.73,0.48-2.74,0.62c-1.04,0.15-2.18,0.22-3.41,0.22c-1.72,0-3.16-0.16-4.33-0.48 c-1.03-0.28-1.86-0.69-2.49-1.22l0,0c-0.66-0.58-1.16-1.27-1.5-2.06c-0.37-0.85-0.57-1.85-0.6-3c-0.01-0.42-0.01-0.79,0-1.11 l0.01,0c0.01-0.44,0.04-0.85,0.07-1.24l0-0.04c0.03-0.44,0.07-0.87,0.13-1.29c0.06-0.42,0.16-0.91,0.27-1.46l0-0.01l8.3-39.95 l0.48-2.29h-2.69h-18.41h-1.78l-0.31,1.52l-8.13,39.44l0,0.02c-0.21,1.07-0.36,1.92-0.46,2.56c-0.12,0.73-0.23,1.48-0.32,2.23 c-0.08,0.64-0.13,1.25-0.16,1.84c-0.03,0.61-0.04,1.16-0.02,1.65l0,0.01c0.05,1.57,0.24,3.09,0.57,4.55 c0.33,1.46,0.81,2.86,1.44,4.21l-0.01,0c0.63,1.38,1.44,2.66,2.42,3.85c0.98,1.18,2.12,2.27,3.43,3.25 c1.29,0.97,2.75,1.83,4.38,2.59l0,0c1.59,0.73,3.36,1.37,5.3,1.89c1.92,0.52,4.02,0.91,6.28,1.16 C138.53,110.32,140.95,110.45,143.51,110.45L143.51,110.45z M242.53,108.71h1.78l0.31-1.51l5.56-26.7l0.14,0.33 c0.4,1,0.82,2.04,1.24,3.12c0.44,1.14,0.87,2.29,1.28,3.43l0,0.01c0.44,1.2,0.91,2.44,1.41,3.69c0.47,1.17,1.02,2.46,1.63,3.86 l-0.01,0c0.59,1.37,1.31,2.69,2.14,3.96c0.83,1.26,1.77,2.46,2.82,3.59l0.02,0.02c1.1,1.16,2.34,2.22,3.7,3.16 c1.34,0.93,2.81,1.75,4.42,2.47l0,0c1.66,0.75,3.53,1.32,5.6,1.69c2.02,0.36,4.23,0.54,6.65,0.54c0.98,0,2-0.04,3.07-0.11 c1.06-0.07,2.12-0.18,3.18-0.33l1.5-0.2l0.27-1.29l2.71-13.17l0.59-2.87c-1.78,0.49-4.27,1.12-6.6,0.56 c-8.85-2.02-13.61-14.84-15.77-20.45l32.55-30.08l3.41-3.15h-28.62l-0.56,0.53l-22.87,21.63c0.13-0.55,0.25-1.06,0.36-1.54 c0.16-0.73,0.35-1.63,0.56-2.67l0.01,0L265,9.02l0.47-2.29h-2.68h-18.38h-1.78l-0.31,1.51l-20.38,98.18l-0.47,2.29h2.68h4.99 H242.53z"
	})
);

var QuikrLogo = function QuikrLogo(props) {
	return quikrLogo__ref;
};
/* harmony default export */ var quikrLogo = (QuikrLogo);
// EXTERNAL MODULE: ../q-cars/src/components/common/Partnerships/index.scss
var Partnerships = __webpack_require__("3fD9");
var Partnerships_default = /*#__PURE__*/__webpack_require__.n(Partnerships);

// CONCATENATED MODULE: ../q-cars/src/components/common/Partnerships/index.js


function Partnerships__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Partnerships__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Partnerships__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Partnerships__ref = Object(preact["h"])(quikrLogo, null);

var Partnerships_PartnershipListing = function (_Component) {
    Partnerships__inherits(PartnershipListing, _Component);

    function PartnershipListing(props) {
        Partnerships__classCallCheck(this, PartnershipListing);

        var _this = Partnerships__possibleConstructorReturn(this, _Component.call(this, props));

        _this.getMetaTags = function () {
            var metaDescription = _this.props.data.metaDescription;

            var tags = [{ "name": "description", "content": metaDescription }];
            tags.push({ "name": "robots", "content": "noindex, nofollow" });
            tags.push({ "name": "googlebot", "content": "noindex, nofollow" });
            return tags;
        };

        var d = new Date();
        _this.Year = d.getFullYear();
        return _this;
    }

    PartnershipListing.prototype.render = function render(props) {
        if (props.data) {
            var banners = Object(CommonHelper["isMobileRequest"])() ? props.data.mobileImages : props.data.desktopImages;
            return Object(preact["h"])(
                'div',
                { 'class': 'bmw--wrapper' },
                Object(preact["h"])(Helmet_default.a, { title: props.data.seoTitle, meta: this.getMetaTags() }),
                Object(preact["h"])(
                    'header',
                    { 'class': 'bmw-header' },
                    Partnerships__ref,
                    Object(preact["h"])('img', { src: props.data.logo, alt: '', 'class': 'bmwlogo' })
                ),
                banners.length > 1 ? Object(preact["h"])(quikrCarousel["a" /* default */], {
                    items: banners.map(function (banner, index) {
                        return Object(preact["h"])('img', { draggable: true, src: banner.imageUrl });
                    }),
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infiniteScrolling: true,
                    autoPlay: true,
                    dots: true,
                    centerMode: false,
                    fixedWidth: false
                }) : Object(preact["h"])('img', { 'class': 'qc-partnerhip__img', src: banners[0].imageUrl, alt: '' }),
                Object(preact["h"])(
                    'div',
                    { 'class': 'bmw__content' },
                    Object(preact["h"])(common_Partnerships_form, { formData: props.data })
                ),
                Object(preact["h"])(
                    'footer',
                    null,
                    'Copyright \xA9 2008-',
                    this.Year,
                    ' Quikr India Private Limited'
                )
            );
        }
    };

    return PartnershipListing;
}(preact["Component"]);

/* harmony default export */ var common_Partnerships = (Partnerships_PartnershipListing);
// EXTERNAL MODULE: ../react-router-dom/es/index.js + 24 modules
var es = __webpack_require__("stbB");

// EXTERNAL MODULE: ../react-redux/es/index.js + 15 modules
var react_redux_es = __webpack_require__("jxGt");

// CONCATENATED MODULE: ../q-cars/src/redux/actions/partnerships.js


var partnerships_partnershipData = function partnershipData(data) {
	return {
		type: 'GET_PARTNERSHIP_DATA',
		axios: true,
		options: {
			url: config["b" /* apiUrl */] + '/partnership/get-partnership-data?aj=1&url=' + data,
			method: 'get'
		}
	};
};
// CONCATENATED MODULE: ../q-cars/src/containers/Partnership/partnershiparea.js


function partnershiparea__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function partnershiparea__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function partnershiparea__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var partnershiparea_Partnership = function (_Component) {
	partnershiparea__inherits(Partnership, _Component);

	function Partnership() {
		partnershiparea__classCallCheck(this, Partnership);

		return partnershiparea__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Partnership.prototype.componentDidMount = function componentDidMount() {
		var path = this.props.match.params.slug;
		this.props.partnershipData(path);
	};

	Partnership.prototype.render = function render(props) {
		return Object(preact["h"])(common_Partnerships, { data: this.props.data });
	};

	return Partnership;
}(preact["Component"]);

var mapStateToProps = function mapStateToProps(state) {
	return {
		data: state.partnerships
	};
};

var partnershiparea_mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		partnershipData: function partnershipData(data) {
			return dispatch(partnerships_partnershipData(data));
		}
	};
};

/* harmony default export */ var partnershiparea = __webpack_exports__["default"] = (Object(es["h" /* withRouter */])(Object(react_redux_es["b" /* connect */])(mapStateToProps, partnershiparea_mapDispatchToProps)(partnershiparea_Partnership)));

/***/ }),

/***/ "yJsN":
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = __webpack_require__("CK2z");

var _react2 = _interopRequireDefault(_react);

var _reactSideEffect = __webpack_require__("lG4b");

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__("PTRK");

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _objectAssign = __webpack_require__("X84d");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__("HipT");

var _PlainComponent = __webpack_require__("GoDe");

var _PlainComponent2 = _interopRequireDefault(_PlainComponent);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var HELMET_ATTRIBUTE = "data-react-helmet";

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props[property]) {
            return props[property];
        }
    }
    return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, "title");
    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");

    return innermostTitle || innermostDefaultTitle || "";
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        return typeof props[tagName] !== "undefined";
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var updateTitle = function updateTitle(title, attributes) {
    document.title = title || document.title;
    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var htmlTag = document.getElementsByTagName(tagName)[0];
    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        htmlTag.setAttribute(attribute, value);

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        htmlTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
    } else {
        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector("head");
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === "innerHTML") {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === "cssText") {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
    var attributeString = generateHtmlAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === "innerHTML" || attribute === "cssText");
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    // assigning into an array to define toString function on it
    var initProps = _defineProperty({
        key: title
    }, HELMET_ATTRIBUTE, true);
    var props = Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var mappedTag = _defineProperty({
            key: i
        }, HELMET_ATTRIBUTE, true);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
                }
            };
        case _HelmetConstants.TAG_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return tags;
                },
                toString: function toString() {
                    return generateHtmlAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var htmlAttributes = _ref.htmlAttributes,
        title = _ref.title,
        titleAttributes = _ref.titleAttributes,
        baseTag = _ref.baseTag,
        metaTags = _ref.metaTags,
        linkTags = _ref.linkTags,
        scriptTags = _ref.scriptTags,
        noscriptTags = _ref.noscriptTags,
        styleTags = _ref.styleTags;
    return {
        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
        }

        _createClass(HelmetWrapper, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, _deepEqual2.default)(this.props, nextProps);
            }
        }, {
            key: "render",
            value: function render() {
                return _react2.default.createElement(Component, this.props);
            }
        }], [{
            key: "canUseDOM",

            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
            /**
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {String} title: "Title"
             * @param {String} defaultTitle: "Default Title"
             * @param {String} titleTemplate: "MySite.com - %s"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             */

        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        htmlAttributes: _react2.default.PropTypes.object,
        title: _react2.default.PropTypes.string,
        defaultTitle: _react2.default.PropTypes.string,
        titleTemplate: _react2.default.PropTypes.string,
        titleAttributes: _react2.default.PropTypes.object,
        base: _react2.default.PropTypes.object,
        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        onChangeClientState: _react2.default.PropTypes.func
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                htmlAttributes: {},
                title: "",
                titleAttributes: {},
                baseTag: [],
                metaTags: [],
                linkTags: [],
                scriptTags: [],
                noscriptTags: [],
                styleTags: []
            });
        }

        return mappedState;
    }, _temp;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        onChangeClientState: getOnChangeClientState(propsList)
    };
};

var handleClientStateChange = function handleClientStateChange(newState) {
    var htmlAttributes = newState.htmlAttributes,
        title = newState.title,
        titleAttributes = newState.titleAttributes,
        baseTag = newState.baseTag,
        metaTags = newState.metaTags,
        linkTags = newState.linkTags,
        scriptTags = newState.scriptTags,
        noscriptTags = newState.noscriptTags,
        styleTags = newState.styleTags,
        onChangeClientState = newState.onChangeClientState;

    updateAttributes("html", htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;

        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    onChangeClientState(newState, addedTags, removedTags);
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(_PlainComponent2.default);

exports.default = Helmet(HelmetSideEffects);
module.exports = exports["default"];

/***/ }),

/***/ "zSvO":
/***/ (function(module, exports) {

var supportsArgumentsClass = function () {
  return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object) {
  return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
};

/***/ })

});


// WEBPACK FOOTER //
// q-cars/src/containers/Partnership/partnershiparea.chun.4df3e.js